





































































































































































































































import { Vue, Component, Prop } from "vue-property-decorator";
import CompanyDTO from "@/dto/company/CompanyDTO";
import CreateRIDCPayload from "@/dto/request/ridc/CreateRIDCPayload";
import {namespace} from "vuex-class";
import RIDCService from "@/services/request/RIDCService";
import SimpleCompanySearch from "@/components/common/SimpleCompanySearch.vue";
import { ifValid, processError } from "@/utils/ComponentUtils";
import PortalCheckbox from "@/components/common/PortalCheckbox.vue";
import PortalInput from "@/components/common/PortalInput.vue";
import PortalSelect from "@/components/common/PortalSelect.vue";
import PhoneInput from "@/components/util/PhoneInput.vue";
import PortalDate from "@/components/common/PortalDate.vue";
import SingleFileHolder from "@/components/util/SingleFileHolder.vue";
import PortalCollapse from "@/components/request/w9cr/PortalCollapse.vue";
import CreateRIDCContractorPayload from "@/dto/request/ridc/CreateRIDCContractorPayload";
import Workspaces from "@/state/Workspaces";
import checkLegalAddress from "@/utils/CheckLegalAddress";
import CompanyService from "@/services/CompanyService";
import BranchDto from "@/components/profile/branches/BranchDtos";
import EmploymentSearch from "@/components/common/EmploymentSearch.vue";
import SelectOption from "@/components/common/SelectOption";
import PersonalDocumentsAggregateDTO from "@/dto/person/PersonalDocumentsAggregateDTO";
import EmployeeDto from "@/dto/payroll/EmployeeDto";
import PersonService from "@/services/PersonService";
import { ResidencyStatus } from "@/constants/PersonConstants";
import BankAccountDTO from "@/dto/BankAccountDTO";

const AppModule = namespace("App");
const Auth = namespace("Auth");

@Component({
  components: {
    PortalCheckbox,
    SimpleCompanySearch,
    EmploymentSearch,
    PortalInput,
    PortalSelect,
    PhoneInput,
    PortalDate,
    SingleFileHolder,
    PortalCollapse,
  },
  computed: {
    ResidencyStatus() {
      return ResidencyStatus
    },
  }
})
export default class CreateRIDC extends Vue {

  @AppModule.Action
  private startLoading!: () => void

  @AppModule.Action
  private stopLoading!: () => void

  @Auth.Getter
  private isAdmin!: boolean;

  @Prop()
  onCreated!: () => void

  @Prop({default: false})
  customerMode!: boolean;

  private payload = new CreateRIDCPayload();
  newContractor = new CreateRIDCContractorPayload();
  contractorDocuments: PersonalDocumentsAggregateDTO | null = null;
  selectedContractor: EmployeeDto | null = null;
  mainBankAccount: BankAccountDTO | null = null;
  branches: BranchDto[] = [];
  hasOfficer = true;
  hasLegalAddress: boolean | void  = true;
  addRegistered = false;
  addMode = true;

  mounted(): void {
    if (this.customerMode) {
      this.payload.companyId = Workspaces.getCurrent.id;
      this.loadBranches(this.payload.companyId);
    }
  }

  create(): void {
    this.startLoading();
    RIDCService.create(this.payload).then(
        ok => {
          this.stopLoading();
          this.onCreated();
        },
        err => {
          this.stopLoading();
          processError(err, this);
        }
    )
  }

  addContractor(): void {
    ifValid(this, () => {
      this.payload.contractors.push(this.newContractor);
      this.newContractor = new CreateRIDCContractorPayload();
      this.contractorDocuments = null;
      this.selectedContractor = null;
      this.mainBankAccount = null;
      this.addRegistered = false;
      this.addMode = false;
    });
  }

  private selectCompany(company: CompanyDTO) {
    this.payload.companyId = company.id;
    this.loadBranches(this.payload.companyId).then(
      async (ok) => {
        await this.checkOfficerPresence();
        this.hasLegalAddress = await checkLegalAddress(this.payload.companyId!, this);
      },
      err => processError(err, this)
    );
  }

  loadBranches(id: number): Promise<void> {
    return CompanyService.getBranches(id).then(response => {
      this.branches = response.data;
      this.addMode = true;
    }).then(
      ok => CompanyService.getHeadQuarter(id).then(response => {
        this.branches.push(response.data)
      })
    );
  }

  checkOfficerPresence(): Promise<void> {
    return CompanyService.getOfficer(this.payload.companyId!).then(
      ok => {
        this.hasOfficer = !!ok.data;
      },
      err => {
        processError(err, this);
      }
    );
  }

  toggleAddMode() {
    this.addMode = !this.addMode;
  }

  contractorChanged(employee: EmployeeDto): void {
    this.newContractor.actualizationOnly = true;
    this.newContractor.contractorId = employee.id;
    this.newContractor.name = employee.details.name;
    this.newContractor.email = employee.details.email;
    this.loadPersonalDocuments();
  }

  private loadPersonalDocuments() {
    if (this.selectedContractor?.details.id) {
      this.startLoading();
      PersonService.getLatestDocumentsAggregate(this.selectedContractor.details.id).then(
        ok => {
          this.contractorDocuments = ok.data;
          this.newContractor.residencyStatus = ok.data.residencyStatus;
          this.newContractor.ssnRequired = !ok.data.ssn;
          this.newContractor.stateIdRequired = !ok.data.stateID;
          this.newContractor.eadRequired = !ok.data.ead && ok.data.residencyStatus == ResidencyStatus.NON_CITIZEN;
          this.newContractor.greenCardRequired = !ok.data.greenCard && ok.data.residencyStatus == ResidencyStatus.PERMANENT_RESIDENT;
          this.newContractor.citizenPassportRequired = !ok.data.citizenPassport && ok.data.residencyStatus == ResidencyStatus.CITIZEN;
          this.stopLoading();
          this.loadBankAccount();
        },
        err => {
          processError(err, this);
          this.stopLoading();
        }
      )
    }
  }

  private loadBankAccount() {
    if (this.selectedContractor?.details.id) {
      this.startLoading();
      PersonService.getBankAccounts(this.selectedContractor?.details.id).then(
        ok => {
          this.mainBankAccount = ok.data.find(acc => acc.isMain) || null;
          this.newContractor.bankDetailsRequired = !this.mainBankAccount;
          this.stopLoading();
        },
        err => {
          processError(this, err);
        }
      )
    }
  }

  onResidencyStatusSelected(): void {
    this.contractorDocuments!.residencyStatus = this.newContractor.residencyStatus;
    this.newContractor.eadRequired = this.newContractor.residencyStatus == ResidencyStatus.NON_CITIZEN && !this.contractorDocuments?.ead;
    this.newContractor.greenCardRequired = this.newContractor.residencyStatus == ResidencyStatus.PERMANENT_RESIDENT && !this.contractorDocuments?.greenCard;
    this.newContractor.citizenPassportRequired = this.newContractor.residencyStatus == ResidencyStatus.CITIZEN && !this.contractorDocuments?.citizenPassport;
  }

  get buildBranches(): Array<SelectOption> {
    return this.branches.map(branch => SelectOption.builder().title(branch.title).value(branch.id).build());
  }

}
